import { ArrowCircleRightOutlined } from "@mui/icons-material";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

type TOwnProps = {
  title: string;
  cardImg?: string;
  actionHandler?: () => void;
};

const MainCard = (props: TOwnProps) => {
  const {
    title,
    cardImg = "/assets/images/offlineThumbnail.png",
    actionHandler,
  } = props;

  return (
    <Grid item width="100%" alignItems="center" justifyContent="space-between">
      <CardActionArea onClick={actionHandler}>
        <Card
          sx={(theme) => ({
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: theme.spacing(0.75),
            paddingRight: theme.spacing(1.5),
            paddingBottom: theme.spacing(0.75),
            paddingLeft: theme.spacing(1),
          })}
        >
          <CardMedia
            sx={{
              width: 70,
              height: 50,
              borderRadius: 12,
              backgroundSize: "cover",
            }}
            component="img"
            image={cardImg}
            title={title}
            alt={title}
          />

          <CardContent>
            <Typography variant="h3" noWrap color="black">
              {title}
            </Typography>
          </CardContent>

          <ArrowCircleRightOutlined />
        </Card>
      </CardActionArea>
    </Grid>
  );
};
export default MainCard;
